import { RegisteredComponent } from "@builder.io/sdk-react";

export const horizontalFilterConfig: Omit<RegisteredComponent, "component"> = {
  name: "Horizontal filter",
  canHaveChildren: false,
  noWrap: true,
  inputs: [
    {
      name: "configuration",
      type: "list",
      helperText:
        "These fields define the configuration of the filters displayed and their order.",
      subFields: [
        {
          name: "parameterName",
          type: "string",
          helperText:
            "The value here must be the same as the one defined under the parameter name in the categorization of the Index card entry.",
          localized: false,
          required: true,
        },
        {
          name: "placeholder",
          type: "string",
          helperText:
            "The placeholder of the filter that will be visible to users.",
          localized: true,
        },
        {
          name: "multiple",
          type: "boolean",
          localized: false,
          required: false,
          helperText:
            "Toggling this field leads to the filter being a multiple choice.",
          defaultValue: false,
        },
        {
          name: "selectAllText",
          type: "string",
          helperText:
            "If this value is provided, the select dropdown adds an additional option to select all options at once with the label provided by this field.",
          localized: true,
          required: true,
          showIf: (options) => options.get("multiple"),
        },
      ],
    },
  ],
};
